const  formatedDate = (date: string) => {
    return date.slice(0,2) + '/' + date.slice(2)
}

export default formatedDate;
